import scrollToElement from "../../utils/scrollToElement";

const createInstance = () => {
  const anchorElement = document.querySelector("#pdp-spare-parts-anchor-wrapper a.pdp-cta--anchor");
  const anchorLabel = document.querySelector("#pdp-spare-parts-anchor-wrapper span.pdp-cta__text");

  const enable = () => {
    anchorElement.setAttribute('href', '#pdp-spare-parts');
    anchorElement.onclick = handleAnchorToSpareParts;
    anchorLabel.classList.remove('pdp-cta__text__loading');
    anchorLabel.textContent = 'View spare parts';
  };

  const disable = () => {
    anchorElement.parentElement.classList.add('hidden');
  };

  return {enable, disable};
};

const handleAnchorToSpareParts = function(e) {
  e.preventDefault();

  const targetElement = document.getElementById("pdp-spare-parts");

  scrollToElement(targetElement);
};

export default createInstance;
